import { ChangeDetectionStrategy, Component, ElementRef, Inject, Input } from '@angular/core';
import { Logo } from '../../models/logo';
import { LOGO } from '../../tokens/config.token';
import { CommonModule } from '@angular/common';
import { IconModule } from '@coreui/icons-angular';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.scss',
  imports: [CommonModule, IconModule],
  // expose css variables on host for external override
  host: {
    style: '--logo-width: var(--logo-size, 100%); --logo-height: var(--logo-size, 100%);'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent {

    @Input() set size(value: string | number | undefined) {
        this.setCssVariable('--logo-size', value);
    }

    @Input() set width(value: string | number | undefined) {
        this.setCssVariable('--logo-width', value);
    }

    @Input() set height(value: string | number | undefined) {
        this.setCssVariable('--logo-height', value);
    }

    private setCssVariable(name: string, value: string | number | undefined) {
        if (value === null || value === undefined) return;
        const val = typeof value === 'number' ? `${value}px` : String(value);
        this.elementRef.nativeElement.style.setProperty(name, val);
    }

    constructor(@Inject(LOGO) public logo: Logo, private elementRef: ElementRef) {}
}
